import _ from 'lodash';
import { DrugAPI, PublicAPI } from '../controllers/api';

// -------------- Locales compiling ------------
const localeLanguageMapper = {
    "OTH": 1,
    "SRB": 6,
    "MNE": 4,
    "MKD": 5,
    "SLO": 7,
    "BIH": 2,
    "CRO": 3
}
//===============================================

class Country {
    _api;
    _publicApi;
    locale;
    list;
    localeChanged;
    translation;
    countries;
    languages;

    constructor(countries, languages){
        this._api = new DrugAPI();
        this._publicApi = new PublicAPI();
        this.countries = countries;
        this.languages = languages;

        this.getCountries = this.getCountries.bind(this);
        this.getLocales = this.getLocales.bind(this);
        this.setLocales = this.setLocales.bind(this);
        this.getCurrentLocale = this.getCurrentLocale.bind(this);
        this.setLocale = this.setLocale.bind(this);
        this.translate = this.translate.bind(this);
        this.compileLocales = this.compileLocales.bind(this);
        this.getCompiledLocales = this.getCompiledLocales.bind(this);
        this.getCompiledLocaleMenuItem = this.getCompiledLocaleMenuItem.bind(this);
        this.compileLocaleElements = this.compileLocaleElements.bind(this);

        this.compileLocaleElements();
        this.compileLocales();

        // if(!!menuItemList) {
        //     var menuLocalItems = _.filter(menuItemList, { localisation: true})
        //     if(menuLocalItems.length > 0) this.list = menuLocalItems[0].subMenu;
        // }
        this.localeChanged = false;

        if( !!localStorage.getItem('lclcntyid') ){
            this.locale = this.getCurrentLocale(parseInt(localStorage.getItem('lclcntyid')));
        } else {
            if( !!localStorage.getItem('accinf') ){
                var accInfo = JSON.parse(localStorage.getItem('accinf'));
                if(!!accInfo.country && !!accInfo.country.countryId) this.locale = this.getCurrentLocale(accInfo.country.countryId);
            } else {
                this.locale = this.getCurrentLocale(7); //{ id: 6.7, title: "Other", code: "OTH", lang: "EN", countryId: 7};
            }
            localStorage.setItem('lclcntyid', this.locale.countryId);
        }

        this.translate();
    }

    compileLocaleElements() {
        this.languages = this.languages.map((l) => { l.element = ("locale-language-" + l.code.toLowerCase()); return l; })
        this.countries = this.countries.map((c) => { c.element = ("locale-country-" + c.code.toLowerCase()); return c; })
    }

    compileLocales(){
        const languagesId = this.languages.map((l) => { return l.languageId; });
        this.list = _.orderBy(this.countries.map((c) => {
            var lLanguage = this.languages[languagesId.indexOf(localeLanguageMapper[c.code])] ;
            return {
                "id": (6 + c.countryId/10),
                "title": c.longName,
                "element": c.element, //"locale-country-" + c.code.toLowerCase(),
                "code": c.code,
                "lang": lLanguage.code,
                "countryId": c.countryId
            }
        }),'title')
    }

    getCompiledLocales(){
        return this.list;
    }

    getCompiledLocaleMenuItem(){
        return {
            "id": 6,
            "title": "English",
            "code": "OTH",
            "lang": "EN",
            "link": "/locale",
            "megaMenu": false,
            "subMenu": this.list,
            "public": true,
            "localisation": true,
            "enabled": true
        }
    }

    getCountries(){
        return this._api.execute('GetCountries')
            .then(callback.bind(this))
            .catch(fallback.bind(this));

        ///------------

        function callback(output){
            return Promise.resolve( output );
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }
    getLocales(){
        return this._publicApi.execute('getLocales')
            .then(callback.bind(this))
            .catch(fallback.bind(this));

        ///------------

        function callback(output){
            return Promise.resolve( output );
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }
    setLocales(){
        this.getLocales().then((lLocales) => {
            var fLocaleList = lLocales.map((lLocale) => {
                return({
                    id: (6+(lLocale.countryId/10)),
                    title: lLocale.longName,
                    code: lLocale.code,
                    lang: lLocale.lang || lLocale.code,
                    countryId: lLocale.countryId
                })
            })
            this.list = fLocaleList });
    }
    getCurrentLocale(countryId){
        var fLocale =  _.filter(this.list, { countryId: countryId} );
        if(fLocale.length == 0) return this.locale;

        return fLocale[0];
    }

    setLocale(countryId){
        var cLocale = this.getCurrentLocale(countryId);
        localStorage.setItem('lclcntyid', countryId);
        this.locale = cLocale;
        this.localeChanged = true;
    }

    translate(){
        var tCode = this.locale.lang || this.locale.code;
        this.translation = require(`../data/localisation/${tCode.toLowerCase()}.json`);
    }
}


export default Country;